import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=0a380176&scoped=true"
import script from "./Attribute.vue?vue&type=script&lang=js"
export * from "./Attribute.vue?vue&type=script&lang=js"
import style0 from "./Attribute.vue?vue&type=style&index=0&id=0a380176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a380176",
  null
  
)

export default component.exports